import React from "react";
import {
  getHighlightedColVal,
  getLastBalance,
  getPayMax,
} from "../../utils/detail";

const HiddenFields = ({ lead_id, caseDetails, user }) => {
  const payMax = getPayMax(caseDetails);
  return (
    <>
      <input type="hidden" name="fcmid" id="fcmid" value={lead_id} />
      <input type="hidden" name="enc_fcmid" id="enc_fcmid" value={lead_id} />
      <input
        type="hidden"
        id="status"
        name="status"
        value={caseDetails.status_id}
      />
      <input
        type="hidden"
        name="disbursementId"
        id="disbursementId"
        value={caseDetails.id}
      />
      <input type="hidden" name="stage" id="stage" value={caseDetails.stage} />
      <input
        type="hidden"
        name="sub_stage"
        id="sub_stage"
        value={caseDetails.sub_stage}
      />
      <input
        type="hidden"
        name="fcm_bank_id"
        id="fcm_bank_id"
        value={caseDetails.fcm_bank_id}
      />
      <input
        type="hidden"
        name="login_user_type"
        id="login_user_type"
        value={user.dts_user}
      />
      <input
        type="hidden"
        name="highlightedCol"
        id="highlightedCol"
        value={getHighlightedColVal(user.dts_user)}
      />
      <input type="hidden" name="pay_max" id="pay_max" value={payMax} />
      <input
        type="hidden"
        name="last_balance"
        id="last_balance"
        value={getLastBalance(caseDetails)}
      />
      <input type="hidden" id="dealer_id" value={caseDetails.dealer_id} />
      <input type="hidden" id="customer_id" value={caseDetails.customer_id} />
      <input
        type="hidden"
        id="tranche_number"
        name="tranche_number"
        value={caseDetails.paymentDetails[payMax - 1].id}
      />
      <input
        type="hidden"
        id="is_super_maker"
        name="is_super_maker"
        value={caseDetails.is_super_maker}
      />
      <input
        type="hidden"
        id="stp_payment"
        name="stp_payment"
        value={caseDetails.stp_payment}
      />
      <input
        type="hidden"
        id="case_type"
        name="case_type"
        value={caseDetails.case_type}
      />
    </>
  );
};

export default HiddenFields;
